/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './styles';
import Launcher from './components/Launcher';
import { sendSupportMessage, connectSocket, fetchSupportMessages } from './actions';

class SCLauncher extends Component {
  state = {
    receiver: localStorage.getItem('__snapcareStaffId__'),
    providerId: localStorage.getItem('__providerId__'),
  };

  componentDidMount() {
    this.props.fetchSupportMessages(this.state.providerId);
    this.props.connectSocket();
  }

  handleMessageSent = (message) => {
    const messageObj = Object.assign({}, message, {
      timestamp: moment.utc().valueOf(),
      receiver: this.state.receiver,
      receiverIdentity: 'SnapcareStaff',
    });
    console.log(messageObj);
    this.props.sendSupportMessage(messageObj);
  };
  render() {
    return (
      <Launcher
        agentProfile={{
          teamName: 'PhyPal Support',
          imageUrl: '',
        }}
        onMessageWasSent={this.handleMessageSent}
        messageList={this.props.messageList}
      />
    );
  }
}

SCLauncher.propTypes = {
  sendSupportMessage: PropTypes.func,
  connectSocket: PropTypes.func,
  messageList: PropTypes.array,
  fetchSupportMessages: PropTypes.func,
};

function mapStateToProps({ support }) {
  return {
    messageList: support.supportMessages,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ sendSupportMessage, connectSocket, fetchSupportMessages }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SCLauncher);
